const lang_th = {
a: "สวัสดี",
};

export default lang_th;
